module.exports = __webpack_public_path__ + "img/dateS.1dcfda2d.svg";